<div
  style="
    background-color: black;
    color: white;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 12px;
  "
>
  {{ text | translate }}
</div>
